<div class="tenant-quota-usage-page" [attr.data-tenant-id]="tenantId || null" testId="tenant-quota-usage-page">
  <nz-spin [nzSpinning]="loading">
    <div class="quota-summary-grid">
      <nz-card class="summary-card summary-card--hero">
        <div class="summary-card__panel summary-card__panel--tint" [testId]="'tenant-quota-usage-summary-quota-count'">
          <div class="summary-card__stat">
            <div class="summary-card__eyebrow">{{ 'tenant.detail.quota-usage-summary-quota-count' | i18n }}</div>
            <div class="summary-card__main">
              <div class="summary-card__value">{{ quotaItemCount }}</div>
              <div class="summary-card__hint">{{ 'tenant.detail.quota-usage-table-name' | i18n }}</div>
            </div>
          </div>
        </div>
        <div class="summary-card__divider"></div>
        <div class="summary-card__panel summary-card__panel--warm" [testId]="'tenant-quota-usage-summary-aile-point'">
          <div class="summary-card__stat summary-card__stat--balance">
            <div class="summary-card__eyebrow">{{ 'tenant.detail.quota-usage-summary-aile-point' | i18n }}</div>
            <div class="summary-card__main">
              <div class="summary-card__value">{{ pointBalance.ailePoint }}</div>
              <div class="summary-card__hint" *ngIf="pointBalance.aipoolTenantId">AIPool: {{ pointBalance.aipoolTenantId }}</div>
            </div>
          </div>
        </div>
      </nz-card>

      <nz-card class="summary-card summary-card--risk" [testId]="'tenant-quota-usage-summary-usage-status'">
        <div class="summary-card__risk-head">
          <div class="summary-card__eyebrow">{{ 'tenant.detail.quota-usage-summary-risk-status' | i18n }}</div>
          <div class="summary-card__risk-dot"></div>
        </div>
        <div class="summary-card__risk-main">
          <div class="summary-card__risk-copy">
            <span class="status-pill" [class]="'status-pill status-pill--' + getRiskColor(riskSummary?.status)">
              {{ getRiskLabel(riskSummary?.status) }}
            </span>
          </div>
          <div class="summary-card__risk-metric">
            <span class="summary-card__risk-value">{{ riskSummary?.overLimitCount ?? 0 }}</span>
            <span class="summary-card__risk-label">{{ 'tenant.detail.quota-usage-summary-over-limit' | i18n }}</span>
          </div>
        </div>
      </nz-card>
    </div>

    <nz-card class="quota-table-card" testId="tenant-quota-usage-table-card">
      <div class="quota-section-head">
        <div>
          <div class="quota-section-head__title">{{ 'tenant.detail.quota-usage-table-title' | i18n }}</div>
          <div class="quota-section-head__meta">
            <span>{{ 'tenant.detail.quota-usage-tenant-name' | i18n }}: {{ detail?.tenantName || tenantName || '--' }}</span>
            <span>{{ 'tenant.detail.quota-usage-plan-name' | i18n }}: {{ detail?.planName || '--' }}</span>
          </div>
        </div>
      </div>

      <ng-container *ngIf="hasQuotaItems; else quotaEmptyTpl">
        <div class="quota-table" testId="tenant-quota-usage-table">
          <div class="quota-table__header">
            <div>{{ 'tenant.detail.quota-usage-table-name' | i18n }}</div>
            <div>{{ 'tenant.detail.quota-usage-table-limit' | i18n }}</div>
            <div>{{ 'tenant.detail.quota-usage-table-used' | i18n }}</div>
            <div>{{ 'tenant.detail.quota-usage-table-remaining' | i18n }}</div>
            <div>{{ 'tenant.detail.quota-usage-table-rate' | i18n }} / {{ 'tenant.detail.quota-usage-table-status' | i18n }}</div>
            <div>{{ 'tenant.detail.quota-usage-table-policy' | i18n }}</div>
          </div>

          <div
            class="quota-table__row"
            *ngFor="let item of quotaItems; let i = index"
            [class.quota-table__row--point-deduct]="isPointDeductPolicy(item)"
            [class.quota-table__row--over-limit]="item.overLimit"
            [attr.data-testid]="'tenant-quota-usage-row-' + (item.quotaCode || i)"
          >
            <div class="quota-table__name" [attr.data-label]="'tenant.detail.quota-usage-table-name' | i18n">
              <div class="quota-table__primary">{{ item.quotaName || item.quotaCode || '--' }}</div>
              <div class="quota-table__secondary" *ngIf="item.quotaCode">{{ item.quotaCode }}</div>
              <div class="quota-table__marker" *ngIf="getQuotaHint(item)">{{ getQuotaHint(item) }}</div>
            </div>
            <div class="quota-table__cell" [attr.data-label]="'tenant.detail.quota-usage-table-limit' | i18n">
              {{ formatQuotaLimit(item) }}
            </div>
            <div class="quota-table__cell" [attr.data-label]="'tenant.detail.quota-usage-table-used' | i18n">
              {{ getUsedValueDisplay(item) }}
            </div>
            <div
              class="quota-table__cell"
              [attr.data-label]="'tenant.detail.quota-usage-table-remaining' | i18n"
              [class.quota-table__cell--muted]="isPointDeductPolicy(item)"
            >
              {{ getRemainingDisplay(item) }}
            </div>
            <div
              class="quota-table__cell quota-table__usage-status"
              [attr.data-label]="'tenant.detail.quota-usage-table-rate' | i18n"
              [class.quota-table__cell--muted]="isPointDeductPolicy(item)"
            >
              <ng-container *ngIf="hasUsageRate(item); else specialUsageTpl">
                <div class="quota-table__usage-wrap">
                  <nz-progress
                    class="quota-table__progress"
                    [nzPercent]="getProgressPercent(item)"
                    [nzShowInfo]="false"
                    [nzStrokeColor]="getProgressStrokeColor(item.status)"
                    [nzStrokeWidth]="10"
                    [nzSize]="'small'"
                  />
                  <div class="quota-table__usage-meta">
                    <span class="quota-table__rate-value">{{ getUsageRateDisplay(item) }}</span>
                    <span class="status-pill" [class]="'status-pill status-pill--' + getStatusColor(item.status)">
                      {{ getStatusLabel(item.status) }}
                    </span>
                  </div>
                </div>
              </ng-container>
              <ng-template #specialUsageTpl>
                <div class="quota-table__usage-wrap quota-table__usage-wrap--special">
                  <span class="status-pill status-pill--green status-pill--soft">
                    {{ getUsageStateLabel(item) }}
                  </span>
                </div>
              </ng-template>
            </div>
            <div class="quota-table__cell quota-table__policy" [attr.data-label]="'tenant.detail.quota-usage-table-policy' | i18n">
              <span class="quota-table__policy-badge">{{ getChargePolicyDisplayLabel(item) }}</span>
            </div>
          </div>
        </div>
      </ng-container>

      <ng-template #quotaEmptyTpl>
        <nz-empty [nzNotFoundContent]="'tenant.detail.quota-usage-empty' | i18n" />
      </ng-template>
    </nz-card>
  </nz-spin>
</div>
